import React from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@carrotfertility/carotene-core';
import { Controller, useFormContext } from 'react-hook-form';
import { getFormInputState } from './form-utils';
import { FormSelectOption, FormSelectProps } from './form-types';

export function FormSelect({
    options,
    helperText,
    label,
    error,
    fullWidth,
    name,
    controllerProps = {},
    ...otherProps
}: FormSelectProps) {
    const labelId = name + '-label';
    const helperTextId = name + '-helper-text';
    const {
        formState: { errors, isSubmitting },
        control,
    } = useFormContext();

    const emptyValue = otherProps?.multiple ? [] : '';

    const { error: hasError, helperText: helperTextValue } = getFormInputState({ name, errors, error, helperText });

    return (
        <FormControl
            data-testid={name}
            error={hasError}
            fullWidth={fullWidth}
            disabled={isSubmitting || otherProps.disabled}
        >
            <InputLabel id={labelId} required={Boolean(controllerProps?.rules?.required)}>
                {label}
            </InputLabel>
            <Controller
                {...controllerProps}
                {...{ control, name }}
                render={({ field }) => (
                    <Select
                        aria-describedby={helperTextId}
                        id={name}
                        {...{ label, labelId }}
                        {...field}
                        {...otherProps}
                        required={Boolean(controllerProps?.rules?.required)}
                        value={field?.value ?? emptyValue}
                    >
                        {options.map((selectOption: FormSelectOption) => (
                            <MenuItem key={selectOption.value} value={selectOption.value}>
                                {selectOption.label}
                            </MenuItem>
                        ))}
                    </Select>
                )}
            />
            {helperTextValue ? <FormHelperText id={helperTextId}>{helperTextValue}</FormHelperText> : null}
        </FormControl>
    );
}
